import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";

import { SNETImageUpload } from "shared/dist/components";
import DummyCardImg from "shared/dist/assets/images/dummy-card.png";
import Typography from "@mui/material/Typography";

import { aiServiceDetailsActions } from "../../../../Services/Redux/actionCreators";
import { assetTypes } from "../../../../Utils/FileUpload";
import classes from "../ServiceProfileImageUpload.module.css";

const ServiceProfileImageUpload = () => {
    const dispatch = useDispatch();
    const { orgUuid } = useParams();
    const [attachments, setAttachments] = useState([]);
    const aiServiceDetails = useSelector((state) => state.aiServiceDetails);

    const handleImageChange = async (data) => {
        const { url } = await dispatch(
            aiServiceDetailsActions.uploadFile(
                assetTypes.SERVICE_ASSETS,
                data,
                orgUuid,
                aiServiceDetails.uuid
            )
        );
        setAttachments([
            {
                file: data,
                url,
            },
        ]);

        dispatch(aiServiceDetailsActions.setServiceHeroImageUrl(url));
        return url;
    };

    return (
        <div className={classes.profileImgContainer}>
            <Typography variant="subtitle1">AI Service Profile Image</Typography>
            <div className={classes.uploaderContentConatiner}>
                <div className={classes.imgUploader}>
                    <SNETImageUpload
                        attachments={attachments}
                        setAttachments={setAttachments}
                        maxImageSizeMB={1}
                        handleImageChange={handleImageChange}
                    />
                </div>
                <div className={classes.profileImgContent}>
                    <Typography variant="subtitle2">
                        Every AI service will have a profile image. We recommend an image that is
                        906 x 504 in size. You can preview how it will look on the AI Marketplace.
                    </Typography>
                    <Typography variant="subtitle2">
                        We encourage to find a representative image for your service that will
                        attract users to explore your page and service.
                    </Typography>
                </div>
            </div>
            <div className={classes.images}>
                <div>
                    <div
                        className={classes.largeImg}
                        style={{
                            backgroundImage: `url(${aiServiceDetails.assets.heroImage.url || DummyCardImg})`,
                        }}
                    />
                    <Typography className={classes.imgDimensionDetails}>
                        302 x 175 | 32-bit PNG or JPG{" "}
                    </Typography>
                </div>
                <div>
                    <div
                        className={classes.smallerImg}
                        style={{
                            backgroundImage: `url(${aiServiceDetails.assets.heroImage.url || DummyCardImg})`,
                        }}
                    />
                    <Typography className={classes.imgDimensionDetails}>
                        207 x 115 | 32-bit PNG or JPG{" "}
                    </Typography>
                </div>
            </div>
        </div>
    );
};

export default ServiceProfileImageUpload;
